import { BlockTypes } from "./block-types";

export enum ConnectorTypes {
  INPUT = "input",
  OUTPUT = "output",
}

export interface Connector {
  inputBlockKey: string;
  outputBlockKey: string;
  id: string;
}

export interface ConnectorMap {
  [key: string]: Connector;
}

export interface ConnectorProps {
  startYPixels: number;
  startXPixels: number;
  endYPixels: number;
  endXPixels: number;
}

export interface ConnectPointClickEvent {
  blockID: string;
  connectorType: ConnectorTypes;
  blockType: BlockTypes;
}

export interface ReactFlowHandleClickEvent {
  nodeID: string;
  type: string; // 'source' | 'target'
}

export interface ReactFlowHandleWithNodeInfo extends ReactFlowHandleClickEvent {
  blockType: BlockTypes;
}
